import script from "./S200.vue?vue&type=script&setup=true&lang=js"
export * from "./S200.vue?vue&type=script&setup=true&lang=js"

import "./S200.vue?vue&type=style&index=0&id=1675cbbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1675cbbc"]])

export default __exports__